import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const UkolForm = lazy(() =>
  import('@/modules/ukoly/UkolForm').then((m) => ({ default: m.UkolForm })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ukoly/novy',
  component: () => (
    <Suspense fallback={null}>
      <UkolForm />
    </Suspense>
  ),
});
